/**
 * Catalogue partagé des formations Believemy.
 * Utilisé par la page /courses et l'API de recommandation IA onboarding.
 *
 * prerequisites: slugs des formations à suivre avant celle-ci (dans l'ordre)
 */

const coursesCatalog = [
    // === BEGINNER ===
    {
        slug: "formation-python",
        title: "Python",
        description:
            "Créez des jeux, des scripts, des bots et analysez des données avec l'un des langages de programmation les plus populaires au monde : Python !",
        level: "beginner",
        duration: "100 heures",
        image: "/images/site/courses/icon-python.png",
        isPopular: true,
        lang: "fr",
        categories: ["developers"],
        prerequisites: [],
    },
    {
        slug: "formation-html",
        title: "HTML & CSS",
        description:
            "Faites vos premiers pas dans le web avec HTML5 et CSS3 avec flexbox et les grilles puis initiez-vous enfin au webdesign pour créer votre premier portfolio professionnel.",
        level: "beginner",
        duration: "50 heures",
        image: "/images/site/courses/icon-html.png",
        isPopular: true,
        lang: "fr",
        categories: ["developers"],
        prerequisites: [],
    },
    {
        slug: "formation-javascript",
        title: "JavaScript",
        description:
            "Créez des sites internet dynamiques grâce à notre formation JavaScript partant de zéro et explorez toutes les dernières nouveautées du langage de programmation le plus populaire des développeurs web.",
        level: "beginner",
        duration: "70 heures",
        image: "/images/site/courses/icon-javascript.png",
        isPopular: true,
        lang: "fr",
        categories: ["developers"],
        prerequisites: ["formation-html"],
    },
    {
        slug: "mettre-son-site-en-ligne-facilement",
        title: "Mettre son site en ligne",
        titleEn: "Putting your site online",
        description:
            "Créez et hébergez votre site web avec Hostinger : facile, abordable et complet, avec e-mails personnalisés et bases du web décryptées.",
        level: "beginner",
        duration: "3 heures",
        image: "/images/site/courses/app-site.png",
        lang: "fr",
        categories: ["developers", "entrepreneurs"],
        prerequisites: [],
    },
    {
        slug: "formation-git-github",
        title: "Git & GitHub",
        description:
            "Créez des versions de votre site internet et revenez aux versions précédentes en un clic ! Supprimez le stress de perdre vos codes pour toujours grâce à GitHub.",
        level: "beginner",
        duration: "10 heures",
        image: "/images/site/courses/icon-git.png",
        lang: "fr",
        categories: ["developers"],
        prerequisites: [],
    },
    {
        slug: "formation-php",
        title: "PHP 8",
        description:
            "Tout ce dont vous avez besoin pour stocker et gérer des données sur vos sites internet !",
        level: "beginner",
        duration: "19 heures",
        image: "/images/site/courses/icon-php.png",
        lang: "fr",
        categories: ["developers"],
        prerequisites: ["formation-html"],
    },
    {
        slug: "formation-bootstrap",
        title: "Bootstrap",
        description:
            "Maîtrisez Bootstrap 5 en créant de véritables projets professionnels et modernes !",
        level: "beginner",
        duration: "15 heures",
        image: "/images/site/courses/icon-bootstrap.png",
        lang: "fr",
        categories: ["developers"],
        prerequisites: ["formation-html"],
    },
    {
        slug: "maitriser-son-nas-synology",
        title: "Maîtriser son NAS Synology",
        titleEn: "Mastering your Synology NAS",
        description:
            "Apprenez à installer, configurer et exploiter tout le potentiel de votre NAS Synology : sauvegardes, cloud, collaboration et multimédia.",
        level: "beginner",
        duration: "5 heures",
        image: "/images/site/courses/icon-nas.png",
        lang: "fr",
        categories: ["developers", "entrepreneurs"],
        prerequisites: [],
    },
    {
        slug: "formation-n8n",
        title: "Créer des automatisations et des agents IA avec n8n",
        titleEn: "Building automations and AI agents with n8n",
        description:
            "Apprenez à automatiser des tâches et créer vos propres agents IA intelligents avec n8n, sans coder une seule ligne avec le no-code.",
        level: "beginner",
        duration: "3 heures",
        image: "/images/site/courses/icon-n8n.png",
        isNew: true,
        lang: "fr",
        categories: ["entrepreneurs", "nocode"],
        prerequisites: [],
    },
    {
        slug: "formation-claude-code",
        title: "Claude Code",
        description:
            "Maîtrisez Claude Code, l'outil d'IA d'Anthropic pour coder plus vite et plus efficacement directement depuis votre terminal.",
        level: "beginner",
        duration: "5 heures",
        image: "/images/site/courses/icon-claudecode.png",
        isNew: true,
        lang: "fr",
        categories: ["developers", "nocode"],
        prerequisites: [],
    },
    {
        slug: "formation-claude-design",
        title: "Claude Design",
        description:
            "Concevez des interfaces et des visuels professionnels en exploitant toute la puissance de l'intelligence artificielle de Claude.",
        level: "beginner",
        duration: "5 heures",
        image: "/images/site/courses/icon-claudedesign.png",
        isSoon: true,
        soonLabelKey: "course_coming_october",
        lang: "fr",
        categories: ["nocode", "entrepreneurs"],
        prerequisites: [],
    },
    {
        slug: "formation-claude-cowork",
        title: "Claude Cowork",
        description:
            "Travaillez en binôme avec Claude : déléguez vos tâches, rédigez, analysez et automatisez votre travail quotidien grâce à l'IA d'Anthropic.",
        level: "beginner",
        duration: "5 heures",
        image: "/images/site/courses/icon-claudecowork.png",
        isSoon: true,
        soonLabelKey: "course_coming_october",
        lang: "fr",
        categories: ["nocode", "entrepreneurs"],
        prerequisites: [],
    },
    {
        slug: "formation-codex",
        title: "Codex",
        description:
            "Confiez votre code à Codex, l'agent de développement d'OpenAI : il lit votre projet, écrit les modifications et lance les tests, et vous validez ce qui part en ligne.",
        level: "beginner",
        duration: "5 heures",
        image: "/images/site/courses/icon-codex.png",
        isSoon: true,
        soonLabelKey: "course_coming_november",
        lang: "fr",
        categories: ["developers", "nocode"],
        prerequisites: [],
    },
    {
        slug: "formation-hermes-agent",
        title: "Hermes Agent",
        description:
            "Installez votre propre agent IA sur votre machine : Hermes garde en mémoire tout ce que vous lui apprenez, se fabrique ses propres compétences et travaille pour vous depuis vos messageries, jour et nuit.",
        level: "beginner",
        duration: "9 heures",
        image: "/images/site/courses/icon-hermesagent.png",
        isNew: true,
        lang: "fr",
        categories: ["nocode", "entrepreneurs"],
        prerequisites: [],
    },
    // === INTERMEDIATE ===
    {
        slug: "formation-react",
        title: "React 19",
        description:
            "Apprenez React 19 en 2025 avec des projets concrets, maîtrisez les Hooks et l'API Context. Formation certifiante pour développeurs tous niveaux.",
        level: "intermediate",
        duration: "90 heures",
        image: "/images/site/courses/icon-react.png",
        isPopular: true,
        lang: "fr",
        categories: ["developers"],
        prerequisites: ["formation-html", "formation-javascript"],
    },
    {
        slug: "formation-tailwindcss",
        title: "Tailwind CSS",
        description:
            "Dominez Tailwind CSS version 4 : apprenez à concevoir des interfaces réactives, claires ou sombres, en un temps record et devenez expert front-end en 2025.",
        level: "intermediate",
        duration: "30 heures",
        image: "/images/site/courses/icon-tailwind.png",
        lang: "fr",
        categories: ["developers"],
        prerequisites: ["formation-html"],
    },
    {
        slug: "formation-mvc",
        title: "PHP & MVC",
        description:
            "Apprenez à professionnaliser et maintenir vos sites internet avec le modèle MVC.",
        level: "intermediate",
        duration: "3 heures",
        image: "/images/site/courses/icon-mvc.png",
        lang: "fr",
        categories: ["developers"],
        prerequisites: ["formation-html", "formation-php"],
    },
    {
        slug: "formation-sass",
        title: "Sass",
        description:
            "L'indispensable, il vous permettra d'aller plus vite dans toutes vos feuilles de style : fonctions, boucles, conditions et bien plus encore, tout ça dans une feuille de style !",
        level: "intermediate",
        duration: "10 heures",
        image: "/images/site/courses/icon-sass.png",
        lang: "fr",
        categories: ["developers"],
        prerequisites: ["formation-html"],
    },
    {
        slug: "formation-typescript",
        title: "TypeScript",
        description:
            "Perfectionnez votre maîtrise de JavaScript grâce à TypeScript : un langage de programmation signé Microsoft qui permet d'ajouter des typages statiques pour rendre plus facilement maintenable son code.",
        level: "intermediate",
        duration: "15 heures",
        image: "/images/site/courses/icon-typescript.png",
        isNew: true,
        lang: "fr",
        categories: ["developers"],
        prerequisites: ["formation-html", "formation-javascript"],
    },
    {
        slug: "formation-symfony",
        title: "Symfony 8",
        description:
            "Créez un site e-commerce complet, un système de paiement et une automatisation par mail pour comprendre le framework Symfony 8.",
        level: "intermediate",
        duration: "50 heures",
        image: "/images/site/courses/icon-symfony.png",
        isSoon: true,
        soonLabelKey: "course_coming_2027",
        lang: "fr",
        categories: ["developers"],
        prerequisites: ["formation-html", "formation-php"],
    },
    {
        slug: "formation-nodejs",
        title: "NodeJS",
        description:
            "Créez des applications JavaScript performantes et scalables avec NodeJS.",
        level: "intermediate",
        duration: "30 heures",
        image: "/images/site/courses/icon-node.png",
        isSoon: true,
        soonLabelKey: "course_coming_2027",
        lang: "fr",
        categories: ["developers"],
        prerequisites: ["formation-html", "formation-javascript"],
    },
    {
        slug: "formation-angular",
        title: "Angular",
        description:
            "Maîtrisez Angular et créez des applications web modernes, performantes et évolutives.",
        level: "intermediate",
        duration: "110 heures",
        image: "/images/site/courses/icon-angular.png",
        isSoon: true,
        soonLabelKey: "course_coming_2027",
        lang: "fr",
        categories: ["developers"],
        prerequisites: ["formation-html", "formation-javascript"],
    },
    // === ADVANCED ===
    {
        slug: "formation-nextjs",
        title: "NextJS 16",
        description:
            "Découvrez comment créer des sites internet plus rapidement et facilement, de manière full-stack et avec une SEO optimisée à la perfection pour les moteurs de recherche avec NextJS 16.",
        level: "advanced",
        duration: "50 heures",
        image: "/images/site/courses/icon-nextjs.png",
        isPopular: true,
        lang: "fr",
        categories: ["developers"],
        prerequisites: [
            "formation-html",
            "formation-javascript",
            "formation-react",
        ],
    },
    {
        slug: "formation-react-native",
        title: "React Native",
        description:
            "Créez des applications mobiles performantes et natives avec React Native, le framework JavaScript le plus populaire pour le développement mobile.",
        level: "advanced",
        duration: "80 heures",
        image: "/images/site/courses/icon-react-native.png",
        lang: "fr",
        categories: ["developers"],
        prerequisites: [
            "formation-html",
            "formation-javascript",
            "formation-react",
        ],
    },
];

/**
 * Retourne toutes les formations du catalogue.
 */
export function getAllCourses() {
    return coursesCatalog;
}

/**
 * Retourne les formations disponibles (non "coming soon") pour la recommandation.
 */
export function getAvailableCourses() {
    return coursesCatalog.filter((course) => !course.isSoon);
}

/**
 * Retourne les formations par niveau.
 */
export function getCoursesByLevel(level) {
    if (level === "discover") return coursesCatalog;
    return coursesCatalog.filter((course) => course.level === level);
}

/**
 * Filtre les formations par catégorie.
 */
export function filterCoursesByCategory(courses, category) {
    if (!category) return courses;
    return courses.filter(
        (course) => course.categories && course.categories.includes(category),
    );
}

/**
 * Titre d'une formation dans la locale demandée.
 * Le catalogue est rédigé en français : seules les formations dont le titre
 * est une phrase (et non un nom de technologie) portent un titleEn.
 */
export function getCourseTitle(course, locale) {
    if (!course) return "";
    if (locale && locale !== "fr" && course.titleEn) return course.titleEn;
    return course.title;
}

/**
 * Trouve une formation par slug.
 */
export function getCourseBySlug(slug) {
    return coursesCatalog.find((course) => course.slug === slug) || null;
}

/**
 * Construit le parcours complet (prérequis + formation cible).
 * Retourne un tableau ordonné de formations, de la base jusqu'à la cible.
 */
export function buildLearningPath(targetSlug) {
    const target = getCourseBySlug(targetSlug);
    if (!target) return [];

    const prerequisites = (target.prerequisites || [])
        .map((slug) => getCourseBySlug(slug))
        .filter(Boolean);

    return [...prerequisites, target];
}
